"use client";

import React from "react";

import { PaymentPlanActivationModal } from "../domains/payment-plan/plan-activate-modal";
import { PermissionNoticeModal } from "../domains/permission/ui/permission-notice-modal";

//

export const ModalProvider: React.FC = () => {
  return (
    <>
      <PaymentPlanActivationModal />
      <PermissionNoticeModal />
    </>
  );
};
